import { render, staticRenderFns } from "./WabaSupsisPartnerAppUninstalled.vue?vue&type=template&id=c8146ca0&scoped=true"
import script from "./WabaSupsisPartnerAppUninstalled.vue?vue&type=script&lang=js"
export * from "./WabaSupsisPartnerAppUninstalled.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisPartnerAppUninstalled.vue?vue&type=style&index=0&id=c8146ca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8146ca0",
  null
  
)

export default component.exports